// Autogenerated file
export const calculateMileageFlagsEnum = {
    Overall: "Overall",
    Active: "Active",
    Stops: "Stops",
    AllMileage: "AllMileage",
    OverallWithStops: "OverallWithStops",
    AllTypes: "AllTypes",
};
export const calculateMileageFlags = [
    { label: "Общий", value: "Overall", intValue: 1 },
    { label: "Активный", value: "Active", intValue: 2 },
    { label: "Остановки", value: "Stops", intValue: 4 },
    { label: "Весь без остановок", value: "AllMileage", intValue: 3 },
    { label: "Общий с остановками", value: "OverallWithStops", intValue: 5 },
    { label: "Все типы пробегов", value: "AllTypes", intValue: 7 },
];
